import { createFileRoute, redirect } from "@tanstack/react-router";
import { PortalVipGate } from "@/components/portal/PortalVipGate";
import { puedeTenerAlias, searchStrings } from "@/lib/portal-alias";
import { resolverAliasPortal } from "@/lib/portal-seo.functions";

export const Route = createFileRoute("/portal-vip/$")({
  // Slugs de ubicaciones fusionadas (alias) → 301 a la URL principal.
  loader: async ({ params, location }) => {
    const segments = (params._splat ?? "").split("/").filter(Boolean);
    const search = searchStrings(location.search);
    if (!puedeTenerAlias(segments, search)) return;
    const alias = await resolverAliasPortal({
      data: { basePath: "/portal-vip", segments, search },
    }).catch(() => null);
    if (alias) {
      throw redirect({
        to: alias.pathname as never,
        search: alias.search as never,
        statusCode: 301,
      });
    }
  },
  component: PortalVipSplat,
});

function PortalVipSplat() {
  const { _splat } = Route.useParams();
  const segs = (_splat ?? "").split("/").filter(Boolean);
  return <PortalVipGate segments={segs} />;
}
